import React, { FC, useState } from "react";
import { PostDataType } from "data/types";
import GallerySlider from "./GallerySlider";
import MediaVideo from "./MediaVideo";
import PostTypeFeaturedIcon from "components/PostTypeFeaturedIcon/PostTypeFeaturedIcon";
import MediaAudio from "./MediaAudio";
import Link from "components/Link";
import Image from "components/Image";
import { BookItem } from "../../type";

export interface PostFeaturedMediaProps {
  className?: string;
  book: BookItem;
  isHover?: boolean;
}

const PostFeaturedMedia: FC<PostFeaturedMediaProps> = ({
                                                         className = "w-full h-full",
                                                         book,
                                                         isHover = false,
                                                       }) => {
  const { poster, url } = book;
  const [imageError, setImageError] = useState(false);
  const handleImageError = (event: React.SyntheticEvent<HTMLImageElement, Event>) => {
    if (!imageError) {
      const imageElement = event.target as HTMLImageElement;
      imageElement.src = "//tranvu.info/logo/vradio_logo_4_3.png"; // Display a fallback image
      setImageError(true);
    }
  };
  return (
    <div className={`nc-PostFeaturedMedia relative ${className}`}>
      <Image
        alt="featured"
        fill
        className="object-cover"
        src={poster}
        sizes="(max-width: 600px) 480px, 800px"
        onError={handleImageError}
      />
      <Link
        href={url}
        className={`block absolute inset-0 bg-black/20 transition-opacity opacity-0 group-hover:opacity-100`}
      />
    </div>
  );
};

export default PostFeaturedMedia;
